import { alpha, mixWhite } from '@wojtekmaj/color-utils';

const colors = {
  'active-menu-item': '#db2f67',
  background: mixWhite('#95d4cb', 0.2),
  'card-background': '#ffffff',
  'dialog-background': mixWhite('#95d4cb', 0.2),
  link: '#db2f67',
  'menu-background': '#ffffff',
  primary: '#db2f67',
  'primary-button-background': '#db2f67',
  'primary-button-disabled-background': '#db2f67',
  'primary-button-disabled-text': '#ffffff',
  'primary-button-focus-background': '#db2f67',
  'primary-button-focus-text': '#ffffff',
  'primary-button-hover-background': '#c50606',
  'primary-button-hover-text': '#ffffff',
  'primary-button-text': '#ffffff',
  'primary-dark': '#c50606',
  'primary-light': '#edb1c9',
  secondary: '#36746e',
  'secondary-button-background': '#00000000',
  'secondary-button-disabled-background': '#00000000',
  'secondary-button-disabled-text': '#db2f67',
  'secondary-button-focus-background': '#00000000',
  'secondary-button-focus-text': '#db2f67',
  'secondary-button-border-color': '#db2f67',
  'secondary-button-hover-background': '#db2f67',
  'secondary-button-hover-text': '#ffffff',
  'secondary-button-text': '#db2f67',
  'secondary-dark': '#0f3a39',
  'secondary-light': '#95d4cb',
  green: '#7fc4bd',
  orange: '#d96032',
  'pink-light': '#fadce9',
  text: '#0f3a39',
  'text-light': alpha('#0f3a39', 0.75),
  'text-muted': alpha('#0f3a39', 0.25),
  'text-on-white': '#0f3a39',
  'text-on-white-light': alpha('#0f3a39', 0.75),
  'text-on-white-muted': alpha('#0f3a39', 0.25),
  'toggle-background': '#c9d9e8',
  'toggle-active-background': '#db2f67',
  overlay: alpha('#e2114f', 0.2),
  'overlay-fallback': mixWhite('#e2114f', 0.2),
  /* Inherited colors */
  black: '#231f20',
  'error-dark': '#c50606',
  'error-light': '#ff746b',
  'error-background': alpha('#ff2323', 0.1),
  gray: '#c9d9e8',
  'gray-light': '#f2f6f8',
  'info-dark': '#026f9c',
  'info-light': '#2ec1ff',
  'info-background': alpha('#00b4ff', 0.1),
  'orange-light': '#fbc288',
  'success-dark': '#106d1f',
  'success-light': '#74d884',
  'success-background': alpha('#2aac3f', 0.1),
  'warning-dark': '#85722f',
  'warning-light': '#ffdd66',
  'warning-background': alpha('#ffdd66', 0.15),
  white: '#ffffff',
} as const;

export default colors;
